import { render, staticRenderFns } from "./IconSet.vue?vue&type=template&id=b626e05c&scoped=true&"
import script from "./IconSet.vue?vue&type=script&lang=ts&"
export * from "./IconSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b626e05c",
  null
  
)

export default component.exports